import Favorites from '@src/main/ui/components/Favorites/Favorites';
import { type FC } from 'react';

const FavoritesPage: FC = () => <Favorites />;

export default FavoritesPage;
